// import {saveShopCartBatch } from '@/api/mall'
import {generateOauthPageUrl,userAuth } from '@/api/weixin'
// import { pay } from 'api/pay'
// import wxShare from '@/wx/wxShare'
// import { error } from 'util';
// generateOauthPageUrl
export default {
    data(){
        return {
            KHchannalId:"",
            KHmemberCode:this.getAppUser("memberCode"),
            // KHShareResetNum:0
        }
    },
    beforeMount(){
        this.KHchannalId = this.$route.params.channalId;
    },
    methods: {
        // 加入购物车
        async _saveShopCartBatch(){
            var localShopCartSpecDTOList = JSON.parse(sessionStorage.getItem("shopCartSpecDTOList")) || [];
            var shopCartSpecDTOList = localShopCartSpecDTOList.map(item=>{
                return {specCode:item.specCode,specCount:item.specCount}
            })
            let memberCode = this.getAppUser("memberCode")
            if(shopCartSpecDTOList.length == 0){
                return
            }
            var data = {
                memberCode,
                shopCartSpecDTOList
            }
            var res = await saveShopCartBatch(data)
            if(res.success){
                sessionStorage.removeItem("shopCartSpecDTOList");
            }else{
                this.$vux.toast.text(res.message)
            }
            Promise.resolve("ok")
        },
        addorgCode(){
            // 首页如果有orgCode则登录的时候加上一个浏览器会话orgCode
            let orgCode = "";
            let arr = window.location.href.split("orgCode=")
            if(arr.length>1){
                var brr = arr[1].split("&")[0];
                orgCode = brr.split("#/")[0];
                sessionStorage.setItem("orgCode",orgCode)
            }
        },  
        async _generateOauthPageUrl({param,state}){
            let memberCode = this.getAppUser("memberCode")
            let KHopenid = sessionStorage.getItem("KHopenid") || "";
            let arr = window.location.href.split("code=")
            let code = "";
            if(arr.length>1){
                var brr = arr[1].split("&")[0];
                code = brr.split("#/")[0];
            }
            if(memberCode || KHopenid || code || !isWeiXin()){
                return ;
            }
            // "redirectUrl":window.location.href,
            var data = {
                appId:this.KHweixin.appid,
                state,
                param,
            }
            // window.vm = this;
            this.$vux.loading.show({text: '正在加载中'})
            generateOauthPageUrl(data).then(res=>{
                if(res.success){
                    window.location.href = res.content.oauth_page_url;
                }
                setTimeout(()=>{
                    this.$vux.loading.hide() 
                },500)
                
            })
        },

        async _userAuth(successCallback){
            var arr = window.location.href.split("code=")
            let code = ""
            if(arr.length>1){
                var brr = arr[1].split("&")[0];
                code = brr.split("#/")[0];
            }
            let KHopenid = sessionStorage.getItem("KHopenid") || "";
            // window.code = code;
            if(!code || KHopenid || !isWeiXin()){
                return ;
            }
            var data = {
                "appId": this.KHweixin.appid,
                "systemType": "3",
                "code":code
            }
            this.$vux.loading.show({text: '正在加载中'})
            userAuth(data).then(res=>{
                if(res.success){
                    localStorage.setItem("user",JSON.stringify(res.content.memberInfo))
                    localStorage.setItem("openid",res.content.weChatUserInfo.openid)
                    sessionStorage.setItem("KHopenid",res.content.weChatUserInfo.openid);
                    successCallback && successCallback();
                }else{
                    // console.log(res.content.weChatUserInfo.openid)
                    localStorage.setItem("openid",res.content.weChatUserInfo.openid)
                    sessionStorage.setItem("KHopenid",res.content.weChatUserInfo.openid)
                }
                this.$vux.loading.hide() 
                // console.log(res)
            }).catch(xhr=>{
                localStorage.setItem("openid",xhr.content.weChatUserInfo.openid)
                sessionStorage.setItem("KHopenid",xhr.content.weChatUserInfo.openid)
                this.$vux.loading.hide() 
            })
        },
        weixinPayHandler(data,successCallback,errorCallback){
            this.$vux.loading.show({text: '正在加载中'})
            pay(data).then(res => {
                this.$vux.loading.hide() 
                // console.log(res)
                if (res.success) {
                    res = res.data;
                    // 唤醒微信支付方法一
                    // wx.chooseWXPay({
                    //     timestamp: res.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                    //     nonceStr: res.nonceStr, // 支付签名随机串，不长于 32 位
                    //     package: res.pkg, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                    //     signType: "MD5", // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                    //     paySign: res.sign, // 支付签名
                    //     success: function (res) {
                    //     // 支付成功后的回调函数
                    //        successCallback && successCallback();
                    //     },
                    //     fail: function (res) {
                    //         errorCallback && errorCallback()
                    //     }
                    // });
                    // 唤醒微信支付方法二
                    function onBridgeReady() {
                        WeixinJSBridge.invoke(
                            'getBrandWCPayRequest', {
                                "appId": res.appId, //公众号名称，由商户传入     
                                "timeStamp": res.timeStamp, //时间戳，自1970年以来的秒数     
                                "nonceStr": res.nonceStr, //随机串     
                                "package": res.pkg,
                                "signType": "MD5", //微信签名方式：     
                                "paySign": res.sign //微信签名 
                            },
                            function(res) {
                                if (res.err_msg == "get_brand_wcpay_request:ok") {
                                    successCallback && successCallback();
                                }else{
                                    errorCallback && errorCallback()
                                }
                            });
                    }
                    if (typeof WeixinJSBridge == "undefined") {
                        if (document.addEventListener) {
                            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                        } else if (document.attachEvent) {
                            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                        }
                    } else {
                        onBridgeReady();
                    }
                }
            })
        },
        KHweixinShareHandler(data){
            clearInterval(window.ShareTimer);
            this.KHShareNum = 0;
            // this. = 0;
            var that = this;
            window.ShareTimer = setInterval(()=>{
                that.KHShareNum++;
                if(window.weixinShareFlag){
                    clearInterval(window.ShareTimer);
                    wxShare.share(data);
                }
                if(that.KHShareNum>5 && that.globalData.KHShareResetNum<2){
                    window.weixinShareFunction();
                    that.KHShareNum = 0;
                    that.globalData.KHShareResetNum ++;
                    // console.log(that.KHShareResetNum)
                }
                if(that.KHShareResetNum>=2){
                    clearInterval(window.ShareTimer);
                }
            },500)
        }
    }
}


//判断是否是微信浏览器的函数
function isWeiXin(){
    //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    var ua = window.navigator.userAgent.toLowerCase();
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    return (ua.match(/MicroMessenger/i) == 'micromessenger')
}


// WEBPACK FOOTER //
// ./src/mixins/common.js